import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import socket from '../../socket';
import Logo from '../../assets/images/logo2.png'
import { Link, useParams } from "react-router-dom";

const Main = (props) => {
  const roomRef = useRef();
  const userRef = useRef();
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const {title, roomId} = useParams();

  useEffect(() => {

    socket.on('FE-error-user-exist', ({ error }) => {
      if (!error) {
        const roomName = roomId;
        const userName = userRef.current.value;

        sessionStorage.setItem('user', userName);
        sessionStorage.setItem('room-title', title);
        props.history.push(`/room/${roomName}`);
      } else {
        setErr(error);
        setErrMsg('User name already exist');
      }
    });
  }, [props.history]);

  function clickJoin() {
    const roomName = roomId;
    const userName = userRef.current.value;

    if (!roomName || !userName) {
      setErr(true);
      setErrMsg('Enter Room Name or User Name');
    } else {
      socket.emit('BE-check-user', { roomId: roomName, userName });
    }
  }

  return (
    <MainContainer>
      <Img src={Logo} />
      <Form>
        <Row>
          <Label htmlFor="roomName">Room Name</Label>
          <Input value={title} type="text" id="roomName" ref={roomRef} readOnly />
        </Row>
        <Row>
          <Label htmlFor="userName">Display Name</Label>
          <Input style={{ backgroundColor: '#fff' }} placeholder='Set your display here' type="text" id="userName" ref={userRef} />
        </Row>
        <JoinButton onClick={clickJoin}> Join Video Meeting </JoinButton>
        {err ? <Error>{errMsg}</Error> : null}
      </Form>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;

  @media only screen and (max-width: 600px) {
    width: 80%;
  }
`;

const Img = styled.img`
  width: auto;
  height: 120px; 
  margin-bottom: 30px;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 15px;
  width: 100%;
  line-height: 35px;
`;

const Label = styled.label`
  color: #000aff;
  font-size: 17px;
`;

const Input = styled.input`
  width: 100%;
  height: 45px;
  margin-left: 0;
  padding-left: 10px;
  outline: none;
  font-size: 17px;
  border: 1px solid #000aff;
  border-radius: 5px;
  background-color: #f1f1f1;
`;

const Error = styled.div`
  margin-top: 10px;
  font-size: 20px;
  color: #e85a71;
`;

const JoinButton = styled.button`
  height: 50px;
  width: 100%;
  margin-top: 35px;
  outline: none;
  border: none;
  border-radius: 15px;
  color: #d8e9ef;
  background-color: #000aff;
  font-size: 20px;
  font-weight: bood;

  :hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

export default Main;